export default __webpack_public_path__ + "static/media/home_thumb_BSM_.c7e78d89.png";